import React from 'react';
import { History } from 'history';
import { Input, InputNumber, InputMultiline, InputSelect, Layout, InputSwitch, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './section-model';  //editable..
import QuizquestionList from '../quizquestion/quizquestion-list.component';
import SectionList from './section-list.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    root?: string;
    caption?: string;
    tag?: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class SectionDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} caption={this.props.caption}
                model={Model} onLoad={this.onLoad} disableCard>              

                <Layout history={this.props.history} content={[
                    {caption: 'Details', child: 
                    <>
                        <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                        <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                        <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                        {AppService.isAppFullVersion() &&
                        <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                        }
                        {this.state.datarow.parent &&
                        <Input name='parentCaption' label='Parent' value={this.state.datarow.parentCaption} readOnly/>
                        }
                        <Input name='title' label='Title' value={this.state.datarow.title} readOnly/>
                        <InputMultiline name='content' label='Content' value={this.state.datarow.content} readOnly/>
                        <InputNumber name='seq' label='Seq' value={this.state.datarow.seq} readOnly/>
                        <InputSelect name='viewstyle' label='View Style' value={this.state.datarow.viewstyle} options={Model.optionViewstyle} readOnly/>
                        <InputNumber name='timelimit' label='Time Limit (Seconds)' value={this.state.datarow.timelimit} readOnly/>
                        <InputNumber name='questiontolerance' label='Question Tolerances' value={this.state.datarow.questiontolerance} readOnly/>
                        <Input name='tag' label='Tag' value={this.state.datarow.tag} error={this.state.errors?.tag} readOnly/>
                    </>
                    },

                    {caption: this.state.datarow.sectionLength > 0? 'Sections' : 'Questions', child: 
                    this.state.datarow.id > 0 && this.props.history &&
                    <>
                        {this.state.datarow.sectionLength > 0?
                        <SectionList history={this.props.history} root={this.props.root} caption='Sub Section' tag={this.props.tag} parentId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                        : <QuizquestionList history={this.props.history} root={this.props.root} sectionId={this.state.datarow.id} actions={['view']} disableBackButton disableCard/>
                        }
                    </>
                    },

                    ]}
                    
                />                
                                
            </BaseDelete>
        );
    }
}